import client from "../client/client";
import { encodeParam } from "../utils/utils";

class RequirementMatrixService {
	getCompaniesSharedPrivacyInProject({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/companies`, { config: { cancelToken } });
	}

	searchDocumentOutInProjectByNameOrRef({ projectId }, { filter, page, limit }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/coverage-document`, {
			params: { filter: encodeParam(filter), page, limit },
			config: { cancelToken },
		});
	}

	searchDocumentsInProjectByName({ projectId }, { filter, page, limit }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/documents`, {
			params: { filter: encodeParam(filter), page, limit },
			config: { cancelToken },
		});
	}

	searchDocumentsInProjectByNameWithFilters({ projectId }, { filters }, { page, limit }, cancelToken) {
		return client.post(`/requirement-matrix/projects/${projectId}/document-details`, {
			payload: filters,
			params: { page, limit },
			config: { cancelToken },
		});
	}

	searchRequirementsInProject({ projectId }, filters, { page = 0, limit = 50 }, cancelToken) {
		return client.put(`/requirement-matrix/projects/${projectId}`, {
			payload: { ...filters, Type: "RequirementSearchFilterDTO", separator: "AND" },
			params: { page, limit },
			config: { cancelToken },
		});
	}

	getRequirementsInProjectCount({ projectId }, filters, cancelToken) {
		return client.put(`/requirement-matrix/projects/${projectId}/count`, {
			payload: { ...filters, Type: "RequirementSearchFilterDTO", separator: "AND" },
			config: { cancelToken },
		});
	}

	getRequirementDetails({ reqId }, cancelToken) {
		return client.get(`/requirement-matrix/requirements/${reqId}`, { config: { cancelToken } });
	}

	getRequirementDetailsMyCompany({ reqId }, cancelToken) {
		return client.get(`/requirement-matrix/requirements/${reqId}/my-company`, { config: { cancelToken } });
	}

	updateRequirement({ reqId }, payload, cancelToken) {
		return client.patch(`/requirement-matrix/requirements/${reqId}`, { payload, config: { cancelToken } });
	}

	getParametersForInformation(cancelToken) {
		return client.get("/requirement-matrix/parameters", { config: { cancelToken } });
	}

	getTotalRequirementsInProject({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/requirements`, { config: { cancelToken } });
	}

	launchImplicitReqAgent({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/agent`, { config: { cancelToken } });
	}

	getImplicitReqAgentConfig({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/ai-config`, { config: { cancelToken } });
	}

	saveImplicitReqAgentConfig(
		{ projectId },
		{ integrationPolicy, documents, additionPrompt, selectDocumentAutomatically },
		cancelToken
	) {
		return client.post(`/requirement-matrix/projects/${projectId}/ai-config`, {
			payload: {
				integrationPolicy,
				documents,
				additionPrompt,
				selectDocumentAutomatically,
			},
			config: { cancelToken },
		});
	}

	rollbackImplicitReqAgentResults({ projectId, agentExecutionId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/agent-execution/${agentExecutionId}/rollback`, {
			config: { cancelToken },
		});
	}

	getImplicitReqAgentHistory({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/history`, { config: { cancelToken } });
	}

	getLastAiAgentExecution({ projectId }, cancelToken) {
		return client.get(`/requirement-matrix/projects/${projectId}/agent/latest-status`, { config: { cancelToken } });
	}
}

export default new RequirementMatrixService();
